import _ from 'lodash';
import { connect } from 'react-redux';
import { search } from '../modules/gasFormula';
import { bindActionCreators } from 'redux';

// XXX memoize
const mapStateToProps = state => {

	/** @namespace state.lists.gasFormulaIds **/
	let gasFormulas = [];
	if (state.lists.gasFormulaIds) {
		gasFormulas = _.map(state.lists.gasFormulaIds, id => state.maps.gasFormula[id]);
	}

	return {
		isSearchingGasFormulas : state.gasFormula.isSearching,
		searchFailedGasFormulas : state.gasFormula.searchFailed,
		gasFormulas : gasFormulas,
		authUser : state.auth.authUser,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	searchGasFormulas : search,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
